import React, { useEffect, useState } from "react";
// import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import FullPageLoader from "../../common/FullPageLoader";
import {
  dropdownSizes,
  dropdownMaterials,
  dropdownFonts,
  dropdownColors,
} from "../../api/dropdownService";
import { addProductVariation } from "../../api/productVariationService";
import { getErrorMessage } from "../../utils/errorHandler";

export default function ProductVariantForm({
  id,
  onSuccess,
  initialVariants = [],
  isEdit = false,
}) {
  const navigate = useNavigate();
  const initialVariation = {
    size: "",
    material: "",
    font: "",
    color: "",
    price: "",
  };
  const [variations, setVariations] = useState([initialVariation]);
  const [sizes, setSizes] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [fonts, setFonts] = useState([]);
  const [colors, setColors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [backendErrors, setBackendErrors] = useState({});

  // const validationSchema = Yup.array().of(
  //   Yup.object().shape({
  //     size: Yup.string().required("Size is required"),
  //     material: Yup.string().required("Material is required"),
  //     price: Yup.number()
  //       .typeError("Price is required")
  //       .positive("Price must be positive")
  //       .required("Price must be a number"),
  //     color: Yup.string(),
  //     font: Yup.string(),
  //   }),
  // );

  useEffect(() => {
    if (isEdit && initialVariants?.length > 0) {
      const mappedVariants = initialVariants.map((variant) => ({
        _id: variant._id,
        size: variant.sizeId?._id || variant.sizeId || "",
        material: variant.materialId?._id || variant.materialId || "",
        font: variant.fontId?._id || variant.fontId || "",
        color: Array.isArray(variant.colorId)
          ? variant.colorId[0]?._id || variant.colorId[0]
          : variant.colorId?._id || variant.colorId || "",
        price: variant.price ?? "",
      }));

      setVariations(mappedVariants);
    }
  }, [initialVariants, isEdit]);

  const fetchSizes = async () => {
    try {
      const response = await dropdownSizes();
      setSizes(response?.data || []);
    } catch (error) {
      alert(getErrorMessage(error));
    }
  };
  const fetchMaterials = async () => {
    try {
      const response = await dropdownMaterials();
      setMaterials(response?.data || []);
    } catch (error) {
      console.log(error);
      alert(getErrorMessage(error));
    }
  };
  const fetchFonts = async () => {
    try {
      const response = await dropdownFonts();
      setFonts(response?.data || []);
    } catch (error) {
      console.log(error);
      alert(getErrorMessage(error));
    }
  };
  const fetchColors = async () => {
    try {
      const response = await dropdownColors();
      setColors(response?.data || []);
    } catch (error) {
      console.log(error);
      alert(getErrorMessage(error));
    }
  };
  useEffect(() => {
    fetchSizes();
    fetchMaterials();
    fetchFonts();
    fetchColors();
  }, []);
  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const updatedVariations = [...variations];
    updatedVariations[index][name] = value;
    setVariations(updatedVariations);
    // REMOVE ERROR
    setErrors((prev) => ({
      ...prev,
      [`[${index}].${name}`]: "",
    }));
  };
  const handleAddVariation = () => {
    setVariations([
      ...variations,
      {
        ...initialVariation,
      },
    ]);
  };
  const handleRemoveVariation = (index) => {
    const updatedVariations = variations.filter((_, i) => i !== index);
    setVariations(updatedVariations);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setErrors({});
      // await validationSchema.validate(variations, {
      //   abortEarly: false,
      // });
      const payload = {
        id,
        variants: variations.map((item) => ({
          sizeId: item.size,
          fontId: item.font,
          materialId: item.material,
          colorId: item.color,
          price: Number(item.price),
        })),
      };
      const response = await addProductVariation(payload);
      setBackendErrors(response.error);
      setSuccessMessage("Variations Added Successfully");
      // CLEAR STORAGE FROM HERE ALSO (IMPORTANT)
      localStorage.removeItem("productStep");
      localStorage.removeItem("productId");
      localStorage.removeItem("productForm");
      setVariations([initialVariation]);
      if (!response?.success) {
        setBackendErrors(response?.error || {});
        return;
      }
      setTimeout(() => {
        if (onSuccess) onSuccess();
        navigate("/products");
      }, 500);
    } catch (error) {
      console.log(error);
      if (error.inner) {
        const formattedErrors = {};
        error.inner.forEach((err) => {
          formattedErrors[err.path] = err.message;
        });
        setErrors(formattedErrors);
        alert(getErrorMessage(error));
      } else {
        setErrors({
          api: error?.response?.data?.message || "Failed To Add Variations",
        });
        alert(getErrorMessage(error));
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="container">
      {loading && <FullPageLoader text="Saving variant..." />}
      <div className="card shadow border-0">
        {/* SUCCESS MESSAGE */}
        {successMessage && (
          <div className="alert alert-success">{successMessage}</div>
        )}
        {/* API ERROR */}
        {errors.api && <div className="alert alert-danger">{errors.api}</div>}
        <form onSubmit={handleSubmit}>
          {variations.map((variation, index) => (
            <div key={index} className="border rounded p-3 mb-4">
              {/* HEADER */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">Variation {index + 1}</h5>
                {index > 0 && (
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={() => handleRemoveVariation(index)}
                  >
                    Remove
                  </button>
                )}
              </div>
              {/* FIRST ROW */}
              <div className="row">
                {/* SIZE */}
                <div className="col-md-3 mb-3">
                  <label className="form-label">
                    Size
                    <span className="error">*</span>
                  </label>
                  <select
                    className={`form-select ${
                      errors[`[${index}].size`] || backendErrors?.sizeId
                        ? "is-invalid"
                        : ""
                    }`}
                    name="size"
                    value={variation.size}
                    onChange={(e) => handleChange(index, e)}
                  >
                    <option value="">Select Size </option>
                    {sizes.map((size) => (
                      <option key={size._id} value={size._id}>
                        {size.value}
                      </option>
                    ))}
                  </select>
                  {errors[`[${index}].size`] && (
                    <div className="invalid-feedback">
                      {errors[`[${index}].size`]}
                    </div>
                  )}
                  {!errors.size && backendErrors?.sizeId && (
                    <div className="invalid-feedback d-block">
                      {backendErrors.sizeId}
                    </div>
                  )}
                </div>
                {/* MATERIAL */}
                <div className="col-md-3 mb-3">
                  <label className="form-label">
                    Material
                    <span className="error">*</span>
                  </label>
                  <select
                    className={`form-select ${
                      errors[`[${index}].material`] ? "is-invalid" : ""
                    }`}
                    name="material"
                    value={variation.material}
                    onChange={(e) => handleChange(index, e)}
                  >
                    <option value="">Select Material</option>
                    {materials.map((material) => (
                      <option key={material._id} value={material._id}>
                        {material.value}
                      </option>
                    ))}
                  </select>
                  {errors[`[${index}].material`] && (
                    <div className="invalid-feedback">
                      {errors[`[${index}].material`]}
                    </div>
                  )}
                  {!errors.material && backendErrors?.sizeId && (
                    <div className="invalid-feedback d-block">
                      {backendErrors.sizeId}
                    </div>
                  )}
                </div>
                {/* COLOR */}
                <div className="col-md-3 mb-3">
                  <label className="form-label">Color<span className="error">*</span></label>
                  <select
                    className={`form-select ${
                      errors[`[${index}].color`] || backendErrors?.colorId
                        ? "is-invalid"
                        : ""
                    }`}
                    name="color"
                    value={variation.color}
                    onChange={(e) => handleChange(index, e)}
                  >
                    <option value="">Select Color</option>
                    {colors.map((color) => (
                      <option key={color._id} value={color._id}>
                        {color.name}
                      </option>
                    ))}
                  </select>
                  {errors[`[${index}].color`] && (
                    <div className="invalid-feedback">
                      {errors[`[${index}].color`]}
                    </div>
                  )}
                  {!errors.color && backendErrors?.colorId && (
                    <div className="invalid-feedback d-block">
                      {backendErrors.colorId}
                    </div>
                  )}
                </div>
                {/* FONT */}
                <div className="col-md-3 mb-3">
                  <label className="form-label">Font<span className="error">*</span></label>
                  <select
                    className={`form-select ${
                      errors[`[${index}].font`] || backendErrors?.fontId
                        ? "is-invalid"
                        : ""
                    }`}
                    name="font"
                    value={variation.font}
                    onChange={(e) => handleChange(index, e)}
                  >
                    <option value="">Select Font</option>
                    {fonts.map((font) => (
                      <option key={font._id} value={font._id}>
                        {font.name}
                      </option>
                    ))}
                  </select>
                  {errors[`[${index}].font`] && (
                    <div className="invalid-feedback">
                      {errors[`[${index}].font`]}
                    </div>
                  )}
                  {!errors.material && backendErrors?.sizeId && (
                    <div className="invalid-feedback d-block">
                      {backendErrors.sizeId}
                    </div>
                  )}
                </div>
              </div>
              {/* SECOND ROW */}
              <div className="row align-items-center">
                {/* PRICE */}
                <div className="col-md-3 mb-3">
                  <label className="form-label">
                    MRP
                    <span className="error">*</span>
                  </label>
                  <input
                    type="number"
                    className={`form-control ${
                      errors[`[${index}].price`] || backendErrors?.price
                        ? "is-invalid"
                        : ""
                    }`}
                    name="price"
                    value={variation.price}
                    onChange={(e) => handleChange(index, e)}
                    placeholder="Enter Price"
                  />
                  {errors[`[${index}].price`] && (
                    <div className="invalid-feedback">
                      {errors[`[${index}].price`]}
                    </div>
                  )}
                  {!errors.price && backendErrors?.price && (
                    <div className="invalid-feedback d-block">
                      {backendErrors.price}
                    </div>
                  )}
                </div>
                {/* ADD BUTTON */}
                <div className="col-md-3 d-flex justify-content-end align-items-center">
                  <button
                    type="button"
                    className="btn btn-primary mt-2"
                    onClick={handleAddVariation}
                  >
                    + Add More
                  </button>
                </div>
              </div>
            </div>
          ))}
          {/* ACTION BUTTONS */}
          <div className="d-flex justify-content-end gap-2">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? "Saving..." : isEdit ? "Update Variations" : "Add Variations"}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => {
                setVariations([initialVariation]);
                navigate("/products");
              }}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
